import { render, staticRenderFns } from "./detailsMovements.vue?vue&type=template&id=9aba69e4&style=background%3A%20var(--v-muted-base)&"
import script from "./detailsMovements.vue?vue&type=script&lang=js&"
export * from "./detailsMovements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports